module.exports = __webpack_public_path__ + "img/28.2cf91167.png";